var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMileageUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3086_6184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8898 3.31562C8.82977 3.31326 6.81208 3.90048 5.07504 5.00793C3.33799 6.11538 1.95415 7.69679 1.08695 9.56541C0.219745 11.434 -0.0945956 13.5118 0.181051 15.5533C0.456698 17.5948 1.31082 19.5148 2.64254 21.0865L2.8389 21.3156H18.9407L19.1371 21.0865C20.4688 19.5148 21.3229 17.5948 21.5986 15.5533C21.8742 13.5118 21.5599 11.434 20.6927 9.56541C19.8255 7.69679 18.4416 6.11538 16.7046 5.00793C14.9675 3.90048 12.9498 3.31326 10.8898 3.31562ZM16.5189 9.52071L12.644 13.3236C12.842 13.7423 12.8857 14.2176 12.7673 14.6653C12.6489 15.1131 12.3759 15.5046 11.9968 15.7707C11.6176 16.0367 11.1566 16.1602 10.6953 16.1192C10.2339 16.0782 9.80188 15.8755 9.47552 15.5468C9.14916 15.2182 8.94949 14.7847 8.9118 14.3231C8.8741 13.8614 9.0008 13.4013 9.26952 13.024C9.53823 12.6468 9.93166 12.3767 10.3803 12.2614C10.8289 12.1461 11.3038 12.1932 11.7211 12.3942L15.5894 8.59125L16.5189 9.52071ZM1.46436 13.5593H3.68981V14.8683H1.43817C1.43817 14.6131 1.40545 14.3643 1.40545 14.1025C1.40545 13.8407 1.41854 13.7425 1.43163 13.5593H1.46436ZM4.65854 7.0138L6.26872 8.62398L5.30654 9.52725L3.68981 7.92362C3.97998 7.59257 4.29273 7.28201 4.62581 6.99416L4.65854 7.0138ZM11.5444 6.9418H10.2353V4.65089H10.8898C11.132 4.65089 11.348 4.65089 11.5444 4.68362V6.9418ZM20.3742 14.1091C20.3742 14.3643 20.3742 14.6262 20.3414 14.8749H18.0374V13.5658H20.348C20.3611 13.7425 20.3742 13.9258 20.3742 14.1091Z",
    fill: "#141414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3086_6184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.0839844 0.482117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMileageUnit);
export default __webpack_public_path__ + "static/media/mileage_unit.51421ab760b308661813f8ec0de70abb.svg";
export { ForwardRef as ReactComponent };